<template>
  <b-row>
    <b-col cols="12">
      <b-row>
        <b-col>
          <router-link :to="{ name: 'InternalAnnouncementList' }" class="btn btn-default float-right">{{$t('buttons.backToList')}}</router-link>
        </b-col>
      </b-row>
    </b-col>
    <b-col>
      <div class="card">
        <template v-if="isLoading">
          <Loader></Loader>
        </template>
        <div class="card-body" v-else>
          <Form
            :handle-submit="onSendForm"
            :handle-update-field="updateField"
            :application-list="applicationList"
            :tag-options="tagOptions"
            :opportunity-options="opportunityOptions"
            :status-options="statusOptions"
            :values="item"
            :errors="violations" />
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import Form from './Form'
import Loader from '@/components/Dashboard/Layout/Loader.vue'
import ApiService from '@/utils/ApiService'

export default {
  name: 'InternalAnnouncementCreate',
  components: { Loader, Form },
  data () {
    return {
      item: {
        applicationType: '/core/public/index.php/api/application_types/1',
        title: '',
        internalDescription: '',
        content: '',
        internalAnnouncementApplication: [],
        priority: 0,
        recipientType: [],
        dateFrom: this.$moment().format('YYYY-MM-DD HH:mm'),
        dateTo: this.$moment().add(30, 'days').format('YYYY-MM-DD HH:mm'),
        published: 0
      },
      applicationList: [],
      tagOptions: [],
      opportunityOptions: [],
      statusOptions: []
    }
  },
  computed: {
    ...mapGetters({
      violations: 'internalannouncement/create/violations',
      isLoading: 'internalannouncement/create/isLoading',
      created: 'internalannouncement/create/created'
    })
  },
  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }

      this.$router.push({ name: 'InternalAnnouncementList' })
    }
  },
  created () {
    this.getApplicationList()
    this.fetchTagOptions()
    this.fetchSalesOpportunities()
    this.fetchStatuses()
  },
  methods: {
    ...mapActions({
      create: 'internalannouncement/create/create'
    }),
    onSendForm (item, publish = 0) {
      this.item.published = publish
      this.create(this.item)
    },
    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    },
    async getApplicationList (internalParams = {}) {
      let params = Object.assign({ pagination: false, disableCheckStatus: 1, state: 1 }, internalParams)
      const response = await new ApiService('applications', params).getResults()
      this.applicationList = response.items.map(item => {
        return {
          value: item['@id'],
          text: item.subdomain
        }
      })
    },
    async fetchTagOptions () {
      let params = { pagination: false, tagType: 2 }
      const response = await new ApiService('e_x_c_m_tags', params).getResults()
      this.tagOptions = response.items.map(tag => {
        return {
          value: tag['@id'],
          text: tag.tag
        }
      })
    },
    async fetchSalesOpportunities () {
      let params = { pagination: false, state: 1 }
      const response = await new ApiService('e_x_c_m_user_data_sales_opportunities', params).getResults()
      this.opportunityOptions = response.items.map(entry => {
        return {
          value: entry['@id'],
          text: entry.title
        }
      })
    },
    async fetchStatuses () {
      let params = { pagination: false, state: 1 }
      const response = await new ApiService('e_x_c_m_user_data_statuses', params).getResults()
      this.statusOptions = response.items.map(entry => {
        return {
          value: entry['@id'],
          text: entry.title
        }
      })
    }
  }
}
</script>
